export const TrackerNames = {
    clientTrackerName: 'clientTracker'
}

export const ActionNames = {
    join: "Join",
    sale: "Sale",
    donation: "Donation"
}

export const TrackerKeys = {
    Google: 'GoogleAnalytics',
    GoogleTagManager: 'GoogleTagManager',
    Facebook: 'FacebookPixel'
};

export const GoogleTagManagerEventKeys = {
    CustomEventTag: "grassrootz_custom_event",
    EcommerceEventTag: "grassrootz_ecommerce_event"
};

export const GoogleAnalyticsEvents = {
    Purchase: "purchase",
};

export const GoogleAnalyticsProperties = {
    Affiliation: "Grassrootz",
};